module.exports = global["FocusTrapReact"] = require("-!./focus-trap-react.js");